import { ExtractPropTypes, PropType, } from 'vue'
import { buildProps } from "@park-ui/utils";
import { ColumnTypes } from "./table-column/defaults";


export const columnPopoverProps = buildProps({
    data: {
        type: Array as PropType<ColumnTypes[]>,
        default: [],
    },
    showIndex: {
        type: Boolean,
    },
    showSelection: {
        type: Boolean,
    },
    mode: String,
    checkbox: {
        type: Array as PropType<Array<string | number>>
    }
},)



export type ColumnPopoverProps = ExtractPropTypes<typeof columnPopoverProps>
